// Reload variants on accessory change (For price update)
window.addEventListener("DOMContentLoaded", () => {
  const selectedVariant = document.querySelector(".variant-input input[data-variant-input]:checked");
  selectedVariant.dispatchEvent(new Event("change"));
});

// Refresh cart Id on add to cart

const url = window.location.href;

document.addEventListener("ajaxProduct:added", function (evt) {
  console.log("cart updated");
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = responseText;
      document.querySelector(".cart-id-container").innerHTML = new DOMParser().parseFromString(html, "text/html").querySelector(".cart-id-container").innerHTML;
    });
});
